import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { DesignFtoPermissionService } from '../design-fto-permission-service';
import type { CheckPLgPermissionOptions } from '@/domains/novelty-check-report/services/novelty-check-permission-service';
import { UserInfoService } from '@telecom/shared/domain/permission/services/user-info-service';
import { CommandService } from '@patsnap/tahiti-core';
import { EditionType } from '@/features/plg-plan/types';

/**
 * DesignFTO模块编辑权限服务实现
 */
@injectable()
export class DesignFtoPermissionServiceImpl implements DesignFtoPermissionService {
    constructor(
        @inject(UserInfoService)
        private readonly _userInfoService: UserInfoService,
        @inject(CommandService)
        private readonly _commandService: CommandService,
    ) {}

    canEdit(): boolean {
        return this._userInfoService.isEnterpriseTenant();
    }

    async checkPLgPermission(callback?: () => void | Promise<void>, options?: CheckPLgPermissionOptions): Promise<void> {
        if (this.canEdit()) {
            if (callback) {
                await callback();
            }
            return Promise.resolve();
        }
        this._commandService.executeCommand('plg:open-plan-list-dialog', {
            // 这里都是pro和免费用户触发,这里需要推荐购买ENTERPRISE
            recommendedPlanId: EditionType.ENTERPRISE,
            agent_name: 'design_fto',
            trigger_source: options?.trigger_source,
        });
        throw new Error('No permission to edit. Enterprise tenant required.');
    }
}
